import React, { useEffect, useState } from 'react';
import Header from '../components/headerComp';
import Menu from '../components/menuComp';
import Footer from '../components/footerComp';
import ProductCard from '../components/productCard';
import { Container, Row } from 'react-bootstrap';

const RCakePage = () => {
  const [rcakeItems, setrcakeItems] = useState([]);

  useEffect(() => {
    fetch('/items.json?v=2')
      .then(response => response.json())
      .then(data => {
        const rcakeItems = data.filter(item => item.category === 'Rcake');
        setrcakeItems(rcakeItems);
      })
      .catch(error => console.error('Error fetching data:', error));
  }, []);

  return (
    <div>
      <Header />
      <Menu />
      <Container className='pb-5 pb-sm-10'>
        <Row>
          {rcakeItems.map(item => (
            <ProductCard key={item.stockNumber} item={item} />
          ))}
        </Row>
      </Container>
      <Footer />
    </div>
  );
}

export default RCakePage;